export const planning = {
  create: 'Créer',
  show_weekends: 'Afficher les weekends',
  my_collaborators: 'Mes collaborateurs',
  my_prestations: 'Mes prestations',
  monday: 'Lun.',
  tuesday: 'Mar.',
  wednesday: 'Mer.',
  thursday: 'Jeu.',
  friday: 'Ven.',
  saturday: 'Sam.',
  sunday: 'Dim.',
  type_week: 'Semaine type',
  current_week: 'Semaine',
  last_connection: 'Dernière connexion',
  account: 'Compte',
  total_planned_hours: 'Total des heures prévues',
  total_worked_hours: 'Total des heures réalisées',
  show_planning: 'Afficher le planning',
  validate_week: 'Valider la semaine',
  modify: 'Modifier',
  validate_week_of: 'Valider la semaine du {{startDate}} au {{endDate}} de',
  validate_week_success: '{{count}} prestation(s) validée(s) avec succès',
  validate_week_empty: 'Aucune prestation à valider pour cette semaine',
  validate_week_error: 'Erreur lors de la validation de la semaine',
  duplicate_planning: 'Copier un planning',
  duplicate_title: 'Copier un planning vers {{firstname}} {{lastname}}',
  duplicate_source_label: 'Sélectionner le collaborateur source',
  duplicate_source_required: 'Merci de sélectionner un collaborateur source',
  duplicate_no_source: 'Aucun collaborateur disponible',
  duplicate_overwrite_label: 'Remplacer la semaine type existante',
  duplicate_mode_label: 'Type de copie',
  duplicate_mode_week_template: 'Vers la semaine type (remplacement longue durée)',
  duplicate_mode_real_week: 'Vers la semaine réelle (remplacement courte durée)',
  duplicate_week_date_label: 'Semaine cible',
  duplicate_action: 'Copier',
  duplicate_success: 'Le planning a été copié avec succès',
  duplicate_error: 'Impossible de copier le planning pour le moment',
};
